// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    screenTitle: string;
    isForExternalUser: boolean;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-MainLayout',
    templateUrl: './MainLayout.html',
    styleUrls: ['./MainLayout.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MainLayout extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.MainLayout';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    sidebar_206 = linkedSignal<boolean>(() => {
        const { screen, app } = this
        if (screen.isForExternalUser) return false
        if (Sys.Layout.isHandset) return false
        const sessionKey = 'sidebar_isOpen'
        if (sessionKey) return sessionStorage.getItem(sessionKey) !== 'false'
        return true
    });
    $validators: Record<number, ValidationRules> = {

    };
    input_screenTitle = input(undefined, { alias: 'screenTitle' });
    var_screenTitle = proxySignal<string>(undefined as any);
    input_isForExternalUser = input(undefined, { alias: 'isForExternalUser' });
    var_isForExternalUser = proxySignal<boolean>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get screenTitle() { return component.var_screenTitle() },
                set screenTitle(value: string) { component.var_screenTitle.set(value) },
                get isForExternalUser() { return component.var_isForExternalUser() },
                set isForExternalUser(value: boolean) { component.var_isForExternalUser.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            screenTitle: this.screen.screenTitle,
            isForExternalUser: this.screen.isForExternalUser
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_screenTitle = this.dialogData?.data?.screenTitle ?? this.input_screenTitle() ?? (undefined)
            if (new_screenTitle !== undefined) this.screen.screenTitle = new_screenTitle


            const new_isForExternalUser = this.dialogData?.data?.isForExternalUser ?? this.input_isForExternalUser() ?? (false)
            if (new_isForExternalUser !== undefined) this.screen.isForExternalUser = new_isForExternalUser

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    toggle_sidebar_206(isOpen?: boolean) {
        if (isOpen === undefined) isOpen = !this.sidebar_206()
        this.sidebar_206.set(isOpen)
        const key = 'sidebar_isOpen'
        if (key) sessionStorage.setItem(key, isOpen.toString())
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            if (!Sys.User.currentUser) Sys.Screen.navigateToScreen(This.$Screens.Login, {})
            if (!screen.screenTitle) screen.screenTitle = Sys.Process.currentTaskDetails?.taskName || ''
            Sys.App.title = screen.screenTitle
        }
    }

    async action_assignToMyself($event?: any) {
        const { app, screen, output } = this
        {
            await Sys.Process.assignCurrentTaskToCurrentUser()
        }
    }
}
